import { BrowserRouter as Router,
	useRoutes }                    from "react-router-dom";

import Home                        from "./pages/home";
import PostBlog                    from "./pages/postBlog";
import ViewBlog                    from "./pages/viewBlog";
import RedoBlog                    from "./pages/redoBlog";
import Dashboard                   from "./pages/dashboard";

//path:'*',          element:<PageNotFound /> }
function AppRoutes () {
	const routes = useRoutes (
		[
			{ path:'/blog',           element: <Home /> },
			{ path:'/blog/post',      element: <PostBlog /> },
			{ path:'/blog/dashboard', element: <Dashboard /> },
			{ path:'/blog/:id',       element: <ViewBlog /> },
			/* blog/edit/:id is not working
			 * so we'll use /blog/edit?url=blog-set-url-by-user
			 */
			{ path:'/blog/edit',      element: <RedoBlog />},
		]
	)
	return routes;
}

export default function App (){
	return (
		<Router>
			<AppRoutes />
		</Router>
	);
};
